/**
 * Safe Google Analytics gtag wrapper
 *
 * Handles cases where gtag hasn't loaded yet (2-second delayed load)
 * or is blocked by ad blockers / privacy settings.
 */
import { trackAnalyticsEvent } from './analytics';

/**
 * Safely call gtag, silently failing if not available.
 * Use this instead of direct window.gtag() calls.
 *
 * @example
 * gtag('event', 'open_report', { type: 'bedek' });
 */
export function gtag(command: string, ...args: any[]): void {
  try {
    if (command === 'event' && typeof args[0] === 'string') {
      trackAnalyticsEvent(args[0], args[1]);
    }

    const w = window as any;
    if (typeof w !== 'undefined' && typeof w.gtag === 'function') {
      w.gtag(command, ...args);
    }
    // Silently ignore if gtag not available - don't pollute console
  } catch {
    // Silently ignore any errors - analytics should never break the app
  }
}
